export default "/images/fb5c5cac11269e330492815909fa47eb.png";